import '../partials/bootstrap'
import '../controllers/email_input_controller'
import '../partials/lightgallery'
import './components/calendar_week_controller'
import '../vendor/cookies';
import '../controllers/local_date_controller';
import '../controllers/view_tour_controller'
import './components/scrollable_container_controller'
import './components/expandable_container_controller'
import '../controllers/add_tour_images_controller'
import '../controllers/quality_bar_chart_controller'
import '../controllers/date_range_picker_controller'
import '../controllers/search_with_suggestions_date_controller'
import '../controllers/add_place_suggested_places_controller';
import '../controllers/add_place_images_controller';

import Chart from 'chart.js/auto'
window.Chart = Chart;

